<template>
    <div class="signature-upload">
        <label>User Signature:</label>
        <img
            v-if="value"
            :src="value"
            alt="User Signature"
            class="signature-upload__preview"
        >
        <p v-if="!value">
            No signature available
        </p>
        <div>
            <label class="signature-upload__btn btn btn-info">Upload New Signature
                <input
                    type="file"
                    @input="uploadFile"
                    accept="image/*"
                >
            </label>
            <button
                class="btn btn-outline-danger"
                @click.prevent="$emit('input', '')"
            >
                Delete Signature
            </button>
        </div>
    </div>
</template>

<script>
import UploadService from '../services/UploadService';

export default {
    props: {
        value: {
            type: [String],
            required: true
        }
    },
    methods: {
        uploadFile ($event) {
            UploadService.upload($event.target.files[0], 600).then(res => {
                this.$emit('input', res.data.full_url);
            })
        }
    },
    
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/SignatureUploadComponent.vue